module.exports = __webpack_public_path__ + "static/media/eu.7b315e3b.png";